export const columns = [
  {
    title: '联系人',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    ellipsis: true,
  },
  {
    title: '营业地址',
    dataIndex: 'address',
    scopedSlots: { customRender: 'address' },
    ellipsis: true,
  },
  {
    title: '联系人号码',
    dataIndex: 'phone_number',
    ellipsis: true,
    width: 200,
  },
  {
    title: '邮箱地址',
    dataIndex: 'email',
    ellipsis: true,
    width: 200,
  },
  {
    title: '操作',
    dataIndex: 'id',
    scopedSlots: { customRender: 'action' },
    width: 60,
  },
];
